export function assertExhaustive(x: never): never {
  throw new Error(`Unhandled case: ${String(x)}`);
}
